import { DroneEntity, DroneStatusType } from '@src/core/features';

/** Ignore stale `missionId` on IDLE unless an active order ties the drone to a mission. */
export function trustedMissionIdFromDrone(drone: DroneEntity | null): string | undefined {
  if (!drone?.missionId) return undefined;
  if (drone.status !== DroneStatusType.IDLE) return drone.missionId;
  const orderId = drone.currentOrderId;
  if (orderId != null && Number(orderId) !== 0) return drone.missionId;
  return undefined;
}
